// extracted by mini-css-extract-plugin
export var productImage = "_105-0";